import claims from '@dtna/dvs-support-dcp-shared-state/lib/utils/claims';

const isFuelPageEnabled = (isFuelAnalyticsEnabled?: boolean | undefined) => isFuelAnalyticsEnabled || claims.isRoot() || (claims.isDtna() && (!(claims.isCsAdmin() || !!claims.isCsAgent() || claims.isOps() || claims.isXota() || claims.isSafety())));

export default isFuelPageEnabled;
